<template>
  <section>
    <el-popover
      v-model="visible"
      popper-class="pop"
      :visible-arrow="false"
      width="181">
      <ul>
        <li @click="handleSelect('zh')">Chinese (Traditional)</li>
        <li @click="handleSelect('en')" >English</li>
      </ul>
      <slot slot="reference"></slot>
    </el-popover>
  </section>
</template>

<script>
export default {
  name: '',
  data () {
    return {
      visible: false,
    }
  },
  methods: {
    handleSelect(lang){
      this.$emit('selectLang', lang)
    }
  },
}
</script>
<style lang='scss'>
.pop{
  padding: 8px !important;
  height: 80px;
  box-shadow: 0px 8px 24px rgba(66, 74, 83, 0.12), 0px 1px 3px rgba(27, 31, 36, 0.12);
  border-radius: 12px;
  display: flex;
  ul{
    flex: 1;
    display: flex;
    flex-direction: column;
    li{
      list-style: none;
      flex: 1;
      height: 20px;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 8px;
      border-radius: 6px;
      cursor: pointer;
      &:hover{
        background: rgba(208, 215, 222, 0.32);
      }
    }
  }
}
</style>
